import React, { useState, useRef, useCallback, memo } from 'react';
import '../App.css'; // Make sure you have the CSS in a file named App.css

// --- ASSET IMPORTS ---
// Using placeholder URLs for demonstration, but local imports are shown.
// Note: Ensure these paths are correct relative to your component file.
import A1 from '../assets/committeeImg/A1.jpg';
import A2 from '../assets/committeeImg/A2.webp';
import B1 from '../assets/committeeImg/B1.jpg';
import B2 from '../assets/committeeImg/B2.webp';
import B3 from '../assets/committeeImg/B3.jpg';
import B4 from '../assets/committeeImg/B4.jpg';
import B5 from '../assets/committeeImg/B5.jpg';
import B6 from '../assets/committeeImg/B6.jpg';
import C1 from '../assets/committeeImg/C1.webp';
import C2 from '../assets/committeeImg/C2.webp';
import C3 from '../assets/committeeImg/C3.jpg';
import C4 from '../assets/committeeImg/C4.jpg';
import C5 from '../assets/committeeImg/C5.webp';
import C6 from '../assets/committeeImg/C6.webp';
import C7 from '../assets/committeeImg/C7.jpg';
import C8 from '../assets/committeeImg/C8.webp';
import C9 from '../assets/committeeImg/C9.jpg';
import C10 from '../assets/committeeImg/C10.webp';
import C11 from '../assets/committeeImg/C11.jpg';
import C12 from '../assets/committeeImg/C12.jpg';
import C13 from '../assets/committeeImg/C13.webp';
import D1 from '../assets/committeeImg/D1.jpg';
import D2 from '../assets/committeeImg/D2.webp';
import E1 from '../assets/committeeImg/E1.jpg';
import E2 from '../assets/committeeImg/E2.jpg';
import E3 from '../assets/committeeImg/E3.jpg';
import E4 from '../assets/committeeImg/E4.webp';
import E5 from '../assets/committeeImg/E5.webp';
import E6 from '../assets/committeeImg/E6.jpg';
import E7 from '../assets/committeeImg/E7.webp';
import F1 from '../assets/committeeImg/F1.jpg';
import F2 from '../assets/committeeImg/F2.jpg';
import F3 from '../assets/committeeImg/F3.jpg';
import F4 from '../assets/committeeImg/F4.jpg';

const defaultAvatar = 'https://placehold.co/300x300/EFEFEF/333?text=Default';


// --- DATA OBJECT ---
// This data is now defined locally, so no import is needed.
const committeeData = {
    special: [
        { id: 'sp1', name: "ബ്രഹ്മശ്രീ തെക്കിനിയേടത് തരണനെല്ലൂർ പത്മനാഭൻ ഉണ്ണി നമ്പൂതിരിപ്പാട്", designation: "തന്ത്രി", img: A1, size: "big" },
        { id: 'sp2', name: "വെലോത്ത് ഗോവിന്ദൻ നമ്പി", designation: "നമ്പി", img: A2, size: "big" }
    ],
    koyma: [
        { id: 'k1', name: "രവീന്ദ്രൻ", designation: "കല്ലിടിൽ തറവാട്", img: B1 },
        { id: 'k2', name: "രാഘുനാഥൻ", designation: "വെള്ളോറ വീട്", img: B2 },
        { id: 'k3', name: "കുഞ്ഞിരാമ പൊതുവാൾ", designation: "കാവിൽ ചൂവാട്ട", img: B3 },
        { id: 'k4', name: "കനുമാഡിൽ നാരായണൻ", designation: "കുപ്ലേരി", img: B4 },
        { id: 'k5', name: "രാജൻ", designation: "പയ്യൻ തറവാട്", img: B5 },
        { id: 'k6', name: "ബാലൻ", designation: "അവറോന്നൻ തറവാട്", img: B6 }
    ],
    anthithiriyan: [
        { id: 'an1', name: "മുണ്ടയാട് കുഞ്ഞിരാമൻ", designation: "അന്തിത്തിരിയൻ", img: C1, size: "big" },
        { id: 'an2', name: "കുപ്പത്തി ഭാസ്കരൻ", designation: "തളികക്കാരൻ", img: C2 },
        { id: 'an3', name: "രാമൻ", designation: "തളികക്കാരൻ", img: C3 },
        { id: 'an4', name: "സുധാകരൻ", designation: "കുപ്പത്തി", img: C4 },
        { id: 'an5', name: "ബാലകൃഷ്ണൻ", designation: "തീക്കടി", img: C5 },
        { id: 'an6', name: "നാരായണൻ", designation: "പുളുക്കൽ", img: C6 },
        { id: 'an7', name: "കൃഷ്ണൻ കാരണവർ", designation: "തായമ്പത്ത്", img: C7 },
        { id: 'an8', name: "നാരായണൻ", designation: "കപ്പച്ചേരി", img: C8 },
        { id: 'an9', name: "കുഞ്ഞമ്പു", designation: "മന്ദ്യത്ത് ", img: C9 },
        { id: 'an10', name: "ജനാർദ്ദനൻ", designation: "ഒടോൽ", img: C10 },
        { id: 'an11', name: "കുഞ്ഞിരാമൻ", designation: "കുയിനൻങ്ങാടൻ", img: C11 },
        { id: 'an12', name: "ദാമോദരൻ", designation: "ചെനാറ്റിൽ", img: C12 },
        { id: 'an13', name: "ദാമോദരൻ", designation: "കാവുതീയ്യ", img: C13 },
    ],
    karanavar: [
        { id: 'd1', name: "മീത്തലെ പുരയിൽ കൃഷ്ണൻ വെളിച്ചപ്പാട്", designation: "മടയിൽ ചാമുണ്ഡി", img: D1 },
        { id: 'd2', name: "കൂറ ഹരിദാസൻ വെളിച്ചപ്പാട് ", designation: "വിഷ്ണു മൂർത്തി", img: D2 },
    ],
    avakashi: [
        { id: 'av1', name: "നളിനി മുണ്ടയാട്ട്", designation: "അടിച്ചു തളി", img: E1 },
        { id: 'av2', name: "സുനിൽ കുമാർ മുണ്ടയാട്ട്", designation: "അടിച്ചുതളി", img: E2 },
        { id: 'av3', name: "ലളിത", designation: "ഇടിച്ചുതര", img: E3 },
        { id: 'av4', name: "സാവിത്രി", designation: "ഇടിച്ചുതര", img: E4 },
        { id: 'av5', name: "ഭാർഗവി", designation: "ഇടിച്ചുതര", img: E5 },
        { id: 'av6', name: "അജിതൻ", designation: "കലശക്കാരൻ", img: E6 },
        { id: 'av6', name: "കൃഷ്ണൻ", designation: "കലശക്കാരൻ", img: E7 }
    ],
    kshethramCommittee: [
        { id: 'kc1', name: "തലയന്നേരി പൂമാല കാവ്", designation: "സമുദായക്കാർ ", img: F1 },
        { id: 'kc2', name: "തലയന്നേരി ", designation: "കൂട്ടായിക്കാർ ", img: F2 },
        { id: 'kc3', name: "കുറിഞ്ഞി ക്ഷേത്രം", designation: "സമുദായക്കാർ", img: F3 },
        { id: 'kc4', name: "കുറിഞ്ഞി ക്ഷേത്രം", designation: "കൂട്ടായിക്കാർ", img: F4 },
    ]
};

// --- COMPONENTS ---

const ImageViewer = ({ src, onClose }) => (
    <div className="image-viewer-overlay active" onClick={onClose}>
        <button className="image-viewer-close" onClick={onClose}>&times;</button>
        <img 
            src={src} 
            alt="Fullscreen view" 
            className="image-viewer-content" 
            onClick={(e) => e.stopPropagation()}
        />
    </div>
);

const MemberCard = memo(({ member, onImageClick }) => (
    <div 
        className={`member-card ${member.size === 'big' ? 'special-member' : ''}`} 
        
    >
        <div className="member-photo-container" onClick={() => onImageClick(member.img || defaultAvatar)}>
            <img 
                src={member.img || defaultAvatar} 
                alt={member.name} 
                className="member-photo" 
                onError={(e) => { e.target.onerror = null; e.target.src = defaultAvatar; }}
            />
        </div>
        <p className="member-name">{member.name}</p>
        <p className="member-designation">{member.designation}</p>
    </div>
));

const HorizontalScrollSection = ({ members, onImageClick }) => {
    const containerRef = useRef(null);
    const isDragging = useRef(false);
    const startX = useRef(0);
    const scrollLeft = useRef(0);

    if (!Array.isArray(members) || members.length === 0) {
        return null;
    }

    const handleDragStart = (e) => {
        const container = containerRef.current;
        if (!container) return;
        
        isDragging.current = true;
        const pageX = e.touches ? e.touches[0].pageX : e.pageX;
        startX.current = pageX - container.offsetLeft;
        scrollLeft.current = container.scrollLeft;
        container.style.cursor = 'grabbing';
    };

    const handleDragEnd = () => {
        const container = containerRef.current;
        if (container) {
            container.style.cursor = 'grab';
        }
        isDragging.current = false;
    };

    const handleDragMove = (e) => {
        if (!isDragging.current) return;
        e.preventDefault();

        const container = containerRef.current;
        if (!container) return;
        
        const pageX = e.touches ? e.touches[0].pageX : e.pageX;
        const x = pageX - container.offsetLeft;
        const walk = (x - startX.current) * 2;
        container.scrollLeft = scrollLeft.current - walk;
    };
    
    return (
        <div
            className="horizontal-scroll-container"
            ref={containerRef}
            onMouseDown={handleDragStart}
            onMouseUp={handleDragEnd}
            onMouseLeave={handleDragEnd}
            onMouseMove={handleDragMove}
            onTouchStart={handleDragStart}
            onTouchEnd={handleDragEnd}
            onTouchMove={handleDragMove}
        >
            <div className="horizontal-scroll-content">
                {members.map(member => (
                    <MemberCard key={member.id} member={member} onImageClick={onImageClick} />
                ))}
            </div>
        </div>
    );
};


const Committee = () => {
    const [viewerImage, setViewerImage] = useState(null);

    const openImageViewer = useCallback((imgSrc) => {
        setViewerImage(imgSrc);
        document.body.classList.add('no-scroll');
    }, []);

    const closeImageViewer = useCallback(() => {
        setViewerImage(null);
        document.body.classList.remove('no-scroll');
    }, []);

    return (
        <>
            <div className="page" id="page6">
                <div className="committee-sections">
                    <div className="committee-section">
                        <h3>പ്രധാനികൾ</h3>
                        <div className="committee-members-grid centered">
                            {committeeData.special.map(member => (
                                <MemberCard key={member.id} member={member} onImageClick={openImageViewer} />
                            ))}
                        </div>
                    </div>

                    <div className="committee-section">
                        <h3>കോയ്മമാർ</h3>
                        <HorizontalScrollSection members={committeeData.koyma} onImageClick={openImageViewer} />
                    </div>

                    <div className="committee-section">
                        <h3>ആചാരക്കാർ</h3>
                        <HorizontalScrollSection members={committeeData.anthithiriyan} onImageClick={openImageViewer} />
                    </div>

                    <div className="committee-section">
                        <h3>ദേവ നർത്തകർ</h3>
                        <div className="committee-members-grid centered">
                            {committeeData.karanavar.map(member => (
                                <MemberCard key={member.id} member={member} onImageClick={openImageViewer} />
                            ))}
                        </div>
                    </div>

                    <div className="committee-section">
                        <h3>ക്ഷേത്രം കമ്മിറ്റി</h3>
                        <HorizontalScrollSection members={committeeData.kshethramCommittee} onImageClick={openImageViewer} />
                    </div>
                     <div className="committee-section">
                        <h3>അവകാശികൾ</h3>
                        <HorizontalScrollSection members={committeeData.avakashi} onImageClick={openImageViewer} />
                    </div>
                </div>
            </div>
            {viewerImage && <ImageViewer src={viewerImage} onClose={closeImageViewer} />}
        </>
    );
};

// --- MAIN APP COMPONENT ---
function App() {
  return (
    <div className="App">
        <main>
            <Committee />
        </main>
    </div>
  );
}

export default App;